import { useEffect, useMemo, useRef, useState } from 'react'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { FilterMatchMode, FilterService } from 'primereact/api'
import {
  capitalizeFirstLetter,
  dynamicCustomFilter,
  generateDropdownOptions,
  handleInputString,
} from '../../../utility/genricFunction'
import { Box, Typography } from '@mui/material'
import { ErrorMessage, Formik } from 'formik'
import NewInput from '../../../components/input/NewInput'
import { numbers, permissions, ROUTES_PATH, UI_CONSTANT } from '../../../utility/constants'
import Button from '../../../components/button/Button'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import PopupBox from '../../../components/popup/PopupBox'
import HorizontalLine from '../../../assets/icons/Line33.svg'
import pencilIcon from '../../../assets/icons/pencil1.svg'
import ModalUnstyled from '../../../components/model/Model'
import closeIcon from '../../../assets/icons/close.svg'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import RightDrawer from '../../../components/drawer/Drawer'
import Loader from '../../../components/loader/Loader'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import ParentDataTable from '../../../components/data-table/ParentDataTable'
import UseAuthorization from '../../../utility/useAuthorization'
import { addArea, editArea } from '../../../store/builders/masterDataSet/masterDataSet.builder'

function AreaList() {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const [archiveId] = useState('')
  const [singleInventoryData, setSingleInventoryData] = useState('')

  const states = useSelector((state) => state?.masterDataSet?.states)
  const stateOptions = useMemo(() => generateDropdownOptions(states, 'state_name', 'state_id'), [states])

  const city = useSelector((state) => state?.masterDataSet?.cites)
  // const cityOptions = useMemo(() => generateDropdownOptions(city, 'city_name', 'city_id'), [city]);
  const { areas, loading } = useSelector((store) => store.masterDataSet)
  // const cityOptions = useMemo(() => generateDropdownOptions(cities, 'city_name', 'city_id'), [cities]);

  const cityOption = useRef([])

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    area_name: { value: null, matchMode: 'dynamic_custom' },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [open, setOpen] = useState(false)
  const [editInventoryDrawer, setEditInventoryDrawer] = useState(false)
  const [openArchive, setOpenArchive] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [filterNumber] = useState(false)

  const handleStateDropdownChange = (e, setFieldValue) => {
    e.preventDefault()
    const stateValue = e.target.value
    setFieldValue('state', stateValue)

    const cities = city.filter((item) => item.state_id === stateValue)

    const cityOptions = cities.map((city) => ({
      label: city.city_name,
      value: city.city_id,
    }))

    cityOption.current = cityOptions?.length ? cityOptions : []
  }

  const handleFormSubmit = (edit) => {
    if (edit) {
      setEditInventoryDrawer(false)
    } else {
      setOpen(false)
    }
  }

  useEffect(() => {
    setFilteredData(areas)
  }, [areas])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(areas, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const toggleDrawerForEditInventory = (newOpen, inquirySourceData) => () => {
    setEditInventoryDrawer(newOpen)
    setIsOpen(true)
    setSingleInventoryData(inquirySourceData)
  }

  const validationSchema = Yup.object().shape({
    areaName: Yup.string().required(VALIDATION_MESSAGES.AREA_NAME_REQUIRED),
    city: Yup.string().required(VALIDATION_MESSAGES.CITY_REQUIRED),
    state: Yup.string().required(VALIDATION_MESSAGES.STATE_REQUIRED),
  })

  const DrawerList = ({ data, edit }) => {
    const [initialValues] = useState({
      areaName: data?.area_name ? data?.area_name : '',
      city: data?.city_id ? data?.city_id : '',
      areaId: data?.area_id ? data?.area_id : '',
      state: data?.city?.state_id ? data?.city?.state_id : '',
    })

    if (edit) {
      const filteredCity = city.filter((item) => item.state_id === data?.city?.state_id)
      cityOption.current = generateDropdownOptions(filteredCity, 'city_name', 'city_id')
    }

    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>
            {edit ? UI_CONSTANT.MASTER_CONFIG.AREA.EDIT_AREA : UI_CONSTANT.MASTER_CONFIG.AREA.ADD_AREA}
          </Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={edit ? toggleDrawerForEditInventory(false) : toggleDrawer(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(value) => {
            handleFormSubmit(edit)
            const data = {
              value,
              setOpen,
            }

            if (edit) {
              dispatch(editArea(data))
            } else {
              dispatch(addArea(data))
            }
          }}
        >
          {({ values, handleChange, handleSubmit, setFieldValue }) => (
            <form>
              <div className='full-form'>
                <div className='first-row'>
                  <div className='first-field'>
                    <label className='branch-inp' htmlFor=''>
                      {UI_CONSTANT.MASTER_CONFIG.AREA.SELECT_STATE}
                      <span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={stateOptions}
                      selectedValue={values.state}
                      className={'branch-dropdown'}
                      onChange={(e) => handleStateDropdownChange(e, setFieldValue)}
                      name={'state'}
                      placeholder={'Select State'}
                    />
                    <ErrorMessage name='state' component='div' className='error-msg' />
                  </div>

                  <div className='first-field'>
                    <label className='branch-inp' htmlFor=''>
                      {UI_CONSTANT.MASTER_CONFIG.AREA.SELECT_CITY}
                      <span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={cityOption.current}
                      selectedValue={values.city}
                      className={'branch-dropdown'}
                      onChange={handleChange}
                      name={'city'}
                      placeholder={'Select City'}
                      disabled={!values.state}
                    />
                    <ErrorMessage name='city' component='div' className='error-msg' />
                  </div>

                  <NewInput
                    label='Area name'
                    placeholder='Enter area name'
                    name='areaName'
                    width={'49%'}
                    type={'text'}
                    required={true}
                    onInput={handleInputString}
                  />
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const nameBody = (areasData) => {
    const representative = areasData?.area_name && capitalizeFirstLetter(areasData?.area_name)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const handleArchiveConfirm = () => {
    setOpenArchive(false)
  }

  const verifiedBodyTemplate = (inquirySourceData) => {
    return (
      <>
        <PopupBox rowData={inquirySourceData} setIsOpen={setIsOpen} isOpen={isOpen}>
          <div className='popupbox'>
            <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

            <img src={HorizontalLine} alt='' />

            {UseAuthorization(permissions.EDIT_INVENTORY) && (
              <button className='div-assign-to-branch' onClick={toggleDrawerForEditInventory(true, inquirySourceData)}>
                <img src={pencilIcon} alt='' />
                <p className='verifiedBodyTemplate-darkfont'>Edit area</p>
              </button>
            )}
          </div>
        </PopupBox>

        {openArchive && (
          <ModalUnstyled
            open={openArchive}
            setOpen={setOpenArchive}
            title={'Archive'}
            BottomButton={'Yes'}
            BottomButton2={'No'}
            className={'archive-model'}
            backgroundColor='rgb(0 0 0 / 0.1)'
            onYes={() => handleArchiveConfirm(archiveId)}
          >
            <div className='model-archive'>
              <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
            </div>
          </ModalUnstyled>
        )}
      </>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'area_name',
      header: 'Area',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.MASTER_CONFIG.AREA.LABEL_AREA,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.MASTER_CONFIG.AREA.LABEL_AREA,
      link: ROUTES_PATH.AREA,
    },
  ]

  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className={`course-list }`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              {UseAuthorization(permissions.ADD_INVENTORY) && (
                <Button className='add-btn' onClick={toggleDrawer(true)}>
                  {UI_CONSTANT.MASTER_CONFIG.AREA.ADD_AREA}
                </Button>
              )}
            </div>
            <RightDrawer anchor='right' isOpen={open} onClose={toggleDrawer(false)}>
              <DrawerList />
            </RightDrawer>
          </div>

          <div className='group-parent'>
            <div className='frame-wrapper'>
              <div className='course-list-wrapper'>
                <b className='course-list1'>{UI_CONSTANT.MASTER_CONFIG.AREA.ALL_AREAS}</b>
              </div>
            </div>
            <div className='flex page-drop-div'>
              <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
              <PageDropdown
                options={numbers}
                selectedValue={selectedNumber}
                onChange={(e) => setSelectedNumber(e.value)}
                className='w-full md:w-14rem small-dropdown'
              />
              <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
            </div>

            <div id='inventory-list-table' className='table-card'>
              <ParentDataTable
                value={filteredData}
                rows={filterNumber ? filteredData.length : selectedNumber}
                filters={filters}
                // loading={loading}
                columns={columns}
                onFilter={onFilter}
              />
            </div>
          </div>
          {editInventoryDrawer && (
            <RightDrawer anchor='right' isOpen={editInventoryDrawer} onClose={toggleDrawerForEditInventory(false)}>
              <DrawerList data={singleInventoryData} edit={true} />
            </RightDrawer>
          )}
        </div>
      )}
    </>
  )
}

export default AreaList
